import React from 'react'

export const TransferCartIcon = () => (
  <svg width="15" height="17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.556 5A.562.562 0 0 1 0 4.445c0-.307.252-.556.556-.556h12.547L10.163.95a.556.556 0 1 1 .785-.787l3.889 3.89a.552.552 0 0 1 .163.393l-.002.05a.56.56 0 0 1-.161.343l-3.89 3.89a.556.556 0 1 1-.785-.788L13.103 5H.556zm13.888 6.667c.307 0 .556.258.556.556a.558.558 0 0 1-.556.555H1.897l2.94 2.94a.556.556 0 0 1-.786.787L.164 12.616A.552.552 0 0 1 0 12.223l.002-.051a.557.557 0 0 1 .161-.343l3.89-3.889a.556.556 0 1 1 .785.787l-2.941 2.94h12.547z"
      fill="#000"
    />
  </svg>
)
